import React, { useEffect, useState } from 'react';
import { actions, EntitiesManager } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core';
import { getStore } from '@comall-backend-builder/core/lib/store';
import { Entity } from '@comall-backend-builder/core/lib/parser';

export interface LoginProps {
    /**
     * 组件绑定的实体
     */
    entities: {
        sessions: Entity;
        privileges: Entity;
    };
    /**
     * logo图片
     */
    logo?: any;
    /**
     * 路由参数
     */
    params: object;
}

export const Login: React.FC<LoginProps> = ({ entities: { sessions, privileges }, params }) => {
    const [isFromAuth, setIsFromAuth] = useState(false);

    // 检测单点登录的 session 信息并自动登录
    useEffect(() => {
        try {
            const ssoSessionUser = window.localStorage.getItem('ssoSessionUser');
            const ssoToken = window.localStorage.getItem('ssoToken');
            if (ssoSessionUser || ssoToken) {
                setIsFromAuth(true);
            }
            if (ssoSessionUser) {
                const user = JSON.parse(ssoSessionUser);
                // 确保 name 字段存在
                if (!user.name && user.username) {
                    user.name = user.username;
                }
                // 自动完成登录
                const store = getStore();
                const entity = new (EntitiesManager.get('privileges'))({});
                store.dispatch(actions.loginSuccessAction(user));
                store.dispatch(actions.getPrivilegeAction(entity, user));
                // 清除 localStorage 中的 session，避免重复登录
                window.localStorage.removeItem('ssoSessionUser');
                window.localStorage.removeItem('ssoToken');
            }
        } catch (e) {
            console.error('自动登录失败', e);
            // 清除可能损坏的数据
            window.localStorage.removeItem('ssoSessionUser');
            window.localStorage.removeItem('ssoToken');
        }
    }, []);

    return (
        <div className="login-container">
            <div className="login-loading">
                <div className="login-loading-wrap">
                    <img
                        src="https://musee.oss-cn-beijing.aliyuncs.com/icon/pzg.png"
                        alt="Logo"
                        className="login-loading-logo"
                    />
                    <div className="login-loading-text">加载中</div>
                    <div className="login-loading-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
            <div className="login-footer">{services.language.getText('common.copyrights')}</div>
        </div>
    );
};
